module.exports = __webpack_public_path__ + "img/stock7.e37764e2.png";